"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StackedbarOptions = /** @class */ (function () {
    function StackedbarOptions() {
        this.width = 500;
        this.height = 500;
        this.data = Promise.resolve([]);
        this.showLegend = true;
        this.showAxis = true;
        this.textX = "";
        this.textY = "";
        this.sort = false;
    }
    return StackedbarOptions;
}());
exports.default = StackedbarOptions;
